import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export type ComparisonCategory = "quizzes" | "flashcards" | "timer" | "workspace";

interface ComparisonBreadcrumbProps {
  platformName: string;
  category?: ComparisonCategory;
}

const categoryConfig: Record<ComparisonCategory, { label: string; path: string }> = {
  quizzes: { label: "Quizzes", path: "/quizzes/" },
  flashcards: { label: "Flash Cards", path: "/flash-cards/" },
  timer: { label: "Study Timer", path: "/study-timer/" },
  workspace: { label: "Online Workspace", path: "/online-workspace/" },
};

export const QuizBreadcrumb = ({ platformName, category = "quizzes" }: ComparisonBreadcrumbProps) => {
  const config = categoryConfig[category];
  
  return (
    <nav className="flex items-center gap-2 text-sm text-muted-foreground mb-8">
      <Link 
        to={config.path}
        onClick={() => window.scrollTo(0, 0)}
        className="hover:text-primary transition-colors"
      >
        {config.label}
      </Link>
      <ChevronRight className="w-4 h-4" />
      <span className="text-foreground font-medium">CSW vs {platformName}</span>
    </nav>
  );
};
